<template>
  <section v-loading.fullscreen.lock="allLoadLoading">
    <el-row>
      <el-col :span="32">
        <div class="grid-content bg-purple" style="margin-top: 10px;color: #495060;">
          <span><el-tag type="success" v-if="this.assessmentFile.Id != ''">{{ this.assessmentFile.HospitalName
              }}</el-tag></span> <span style="margin-left: 10px;">档案号：<el-tag type="success"
              v-if="this.assessmentFile.Id != ''">{{ this.assessmentFile.Number
              }}</el-tag></span>
          <span style="margin-left: 10px;">负责人：
            <template>
              <el-tag type="success" v-if="this.assessmentFile.ScoreUserName !== ''">
                {{ this.assessmentFile.ScoreUserName }}
              </el-tag>
            </template>
          </span>
          <span style="margin-left: 10px;">档案状态：
            <template>
              <el-tag type="success">
                {{ getStateText(this.assessmentFile.State) }}
                <!-- {{ this.assessmentFile.State }} -->
              </el-tag>
            </template>
          </span>
          <span style="margin-left: 10px;">未提交模块：
            <template>
              <el-tag type="success">
                {{ countmodulState('UnSubmitted') }}
              </el-tag>
            </template>
          </span>
          <span style="margin-left: 10px;">已提交模块:
            <el-tag type="success">
              {{ countmodulState('Submitted') }}
            </el-tag>
          </span>
          <span style="margin-left: 10px;">已通过模块：
            <el-tag type="success">
              {{ countmodulState('Approved') }}
            </el-tag>
          </span>
          <span style="margin-left: 10px;">未通过模块
            <template>
              <el-tag type="success">
                {{ countmodulState('UnApproved') }}
              </el-tag>
            </template>
          </span>
          <transition name="el-zoom-in-top">
            <label>
              <span style="margin-left: 100px">分数：</span>
              <span style="font-family: 微软雅黑;font-size: 15px;color: #E6A23C;">{{
                this.modulestateCount.Socouresd }}</span>
            </label>

          </transition>
        </div>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <el-col :span="32">
        <div class="grid-content bg-purple">
          <el-input prefix-icon="el-icon-search" v-model="input" style="width: 300px;" placeholder="请输入标准序号、评审模块"
            @keyup.enter.native="handleQuery"></el-input>
          <el-select v-model="zrrId" placeholder="请选择责任人" style="margin-left: 15px" :clearable="true"
            @change="zzrchangehandler">
            <el-option v-for="item in zrrOptions" :key="item.Zzrid" :label="item.Zzrname" :value="item.Zzrid">
            </el-option>
          </el-select>
          <el-select v-model="isstorard" placeholder="请选择是否达标" :clearable="true" style="margin-left: 15px;"
            @change="storardhandler">
            <el-option label="达标" :value="true"></el-option>
            <el-option label="不达标" :value="false"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="16">
        <div class="grid-contentbutton">
          <el-button style="margin-left: 15px" type="primary" @click="Generatefile"
            :disabled="this.assessmentFile.State > 3">生成考核档案</el-button>
          <el-button type="danger" @click="shenghestate"
            :disabled="this.assessmentFile.State == 6 || this.assessmentFile.Id == ''">归档</el-button>
          <el-button type="success" @click="getkoufen">扣分原因</el-button>
        </div>
      </el-col>
    </el-row>
    <div style="margin-top: 20px;">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="Level" label="重要程度" width="80" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Level === 1" effect="dark" type="success">低</el-tag>
            <el-tag v-if="scope.row.Level === 2" effect="dark" type="warning">中</el-tag>
            <el-tag v-if="scope.row.Level === 3" effect="dark" type="danger">高</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="IsStandards" label="是否达标" width="80" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsStandards === true" effect="dark" type="success">已达标</el-tag>
            <el-tag v-if="scope.row.IsStandards === false" effect="dark" type="warning">未达标</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="StIndex" label="标准序号" width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="ReviewContent" label="评审模块" width="350" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="Stoverview" label="标准概述" width="300" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="Stscore" label="标准分值" width="80" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="PersonLiableName" label="责任人" width="80" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="Zrbm" label="责任部门" width="150" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="Xzbm" label="协助部门" width="150" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="CreateTime" label="评审时间" width="200" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="Score" label="得分" width="100" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <!--工具条-->
    <!-- <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize"
        :total="total" style="float: right"></el-pagination>
    </el-col> -->
    <el-col :span="24" class="toolbar">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
        :page-size="pageSize" :page-sizes="[10, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-col>

    <el-dialog title="生成考核" :visible.sync="dialogshencVisible" width="30%" :destroy-on-close="true"
      @close="handleClose">
      <el-form :model="dangantableForm" label-position="right" :rules="dialogshengcRules" ref="dangantableForm">
        <el-form-item label="考核档案" label-width="120px" prop="checkValue">
          <el-select v-model="dangantableForm.checkValue" placeholder="请选择考核档案">
            <el-option v-for="item in checkData" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="负责人" prop="PersonLiableId" label-width="120px">
          <el-select v-model="dangantableForm.PersonLiableId" filterable placeholder="请选择模块负责人"
            @change="handlePersonLiableChange">
            <el-option v-for="item in users" :key="item.UId" :value="item.UId" :label="labelContent(item)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogshencVisible = false">取 消</el-button>
        <el-button @click.native="submitGenerate" type="primary" :loading="addLoading">生成考核档案</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扣分明细" :visible.sync="diakoufenmxVisible" width="80%">
      <el-table :data="Koufenmingxitable" style="width: 100%;">
        <el-table-column prop="Modulstindex" label="模块序号" width="80">
        </el-table-column>
        <el-table-column prop="ModulName" label="评审模块" width="330" :show-overflow-tooltip="true">
        </el-table-column>
        <!-- <el-table-column prop="Level" label="等级" width="60">
        </el-table-column> -->
        <el-table-column prop="Level" label="重要程度" width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Level === 1" effect="dark" type="success">低</el-tag>
            <el-tag v-if="scope.row.Level === 2" effect="dark" type="warning">中</el-tag>
            <el-tag v-if="scope.row.Level === 3" effect="dark" type="danger">高</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ReviewMethod" label="评审方法" width="300" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="ReviewPoints" label="评审要点" width="300" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="Assessmentdetailstindex" label="考核细项序号" width="110">
        </el-table-column>
        <el-table-column prop="Reasondemerit" label="扣分原因" width="150">
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="diaghandleCurrentChange" :page-size="diagpageSize"
          :total="diagtotal" style="float: right"></el-pagination>
      </el-col>
    </el-dialog>
  </section>

</template>

<script>
import LookDocument from './../../components/LookDocument.vue';
import {
  getAssessmentFile,
  getEvaluationAgencyList,
  generateAssessment,
  editAssementFile,
  editAssementFileState,
  getModuleStateCount,
  asseDetailbadmessage,
  getAssementFileList,
  getzzrOptions,
} from "../../api/EvaluationAgency/EvaluationAgency";
import {
  GetDepartmentList,
  getUsers,
} from "../../api/api";
import {
  GetPublicParamsLs,
} from "../../api/PublicParams/PublicParams";
import { GetCheck } from "../../api/RatingManage/RatingManage";
import * as api from '../../api/api';
import { Loading } from 'element-ui';
import PublicParams from '../PublicParams/PublicParams.vue';
export default {
  props: ["ratingData", "checkpValue", "fileManagermentPassId"],
  data () {
    return {
      reason: "",
      allLoadLoading: false,
      tableData: [],
      input: "",
      pageIndex: 1,
      total: 0,
      pageSize: 10,
      diagpageIndex: 1,
      diagpageSize: 10,
      diagtotal: 0,
      checkValue: "",//当前考核表Id
      PersonLiableId: "",
      assessmentFile: {
        HospitalName: "",
        Number: "",
        Id: "",
        State: "",
        ScoreUserName: ""
      },
      checkData: [],//当前考核表数据
      hospitalId: "",
      fileManagermentFileId: null,//档案管理界面传的档案ID
      dialogshencVisible: false,
      dangantableForm: {
        checkValue: "",
        PersonLiableId: "",
      },//生成考核档案
      users: [],
      depts: [],
      addLoading: false,
      dialogshengcRules: {
        checkValue: [
          { required: true, message: "请选择考核档案", trigger: "change" },
        ],
        PersonLiableId: [
          { required: true, message: "请选择负责人", trigger: "change" },
        ],

      },
      realName: "",
      publicParam: [],//参数管理
      modulestateCount: [],//统计模块状态
      zrrOptions: [],//责任人选项
      zrrId: "",
      zrrName: "",
      isstorard: null,//是否达标
      diakoufenmxVisible: false,
      Koufenmingxitable: [],
      assementfileCount: 0,//当前未归档的条数
    }
  },
  methods: {
    handleClose () {
      this.$refs.dangantableForm.resetFields(); // 重置表单

    },
    handleSizeChange (size) {
      this.pageSize = size;
      this.pageIndex = 1// 当更改分页大小时，重置为第一页
      this.handleQuery();
    },
    handleCurrentChange (val) {
      this.pageIndex = val;
      this.handleQuery();
    },
    diaghandleCurrentChange (val) {
      this.diagpageIndex = val;
      this.getassedetailbadmessage();
    },
    //获取考核表
    async GetCheckData () {
      let para = {
        page: 1,
        key: "",
        pageSize: 1000,
      };
      await GetCheck(para).then((res) => {
        if (res.data.success && res.data.response.dataCount > 0) {
          this.checkData = res.data.response.data;
          this.checkValue = this.checkData[0].Id;
        }
      });
    },
    async loadApiData () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.checkData.length === 0) {
        this.$message({
          message: '请维护考核基础数据',
          type: 'warning'
        });
      }
      if (this.checkData.length > 0) {
        //加载考核档案数据
        console.log("加载考核档案数据");
        await this.loadAssessmentFile();
      }

      loading.close();
    },
    //生成考核档案
    async Generatefile () {
      await this.getassementfileList();
      if (this.assementfileCount >= 1) {
        this.$message({
          showClose: true,
          message: '当前已经有考核档案,不能多次生成档案',
          type: 'warning'
        });
        return;
      }
      await this.getUsersQuery();
      await this.getDeptList();
      this.dialogshencVisible = true;
    },
    //提交生成考核
    submitGenerate () {
      this.$refs.dangantableForm.validate(valid => {
        if (valid) {
          let para = Object.assign({}, this.dangantableForm);
          console.log(JSON.stringify(para) + "提交生成参数");
          console.log("选中的考核id" + para.checkValue);
          this.checkValue = para.checkValue;
          this.PersonLiableId = para.PersonLiableId;
          this.build();
          this.dialogshencVisible = false;
        } else {
          // 如果表单验证不通过，可以做一些提示或者其他处理
          this.$message.error('表单验证未通过，请检查输入！');
        }
      });

    },
    //加载考核档案数据
    async loadAssessmentFile () {
      var parms = { hospitalId: this.hospitalId, fileId: this.fileManagermentFileId };
      console.log("oarms" + JSON.stringify(parms));
      await getAssessmentFile(parms).then((res) => {
        this.assessmentFile = res.response;
        if (this.assessmentFile == null) {
          this.$message({
            message: '暂无考核档案,请先去生成考核档案',
            type: 'warning'
          });
          this.tableData = [];
          this.dataCount = 0;
          this.assessmentFile = {
            HospitalName: "",
            Number: "",
            Id: "",
            State: "",
            ScoreUserName: ""
          };
        }
        else {
          console.log("进入handlerquery");
          //已归档不能查询数据
          if (this.assessmentFile.State !== 6) {
            this.handleQuery()
          }

        }
      });
    },
    async getassedetailbadmessage () {
      let params = {
        Page: this.diagpageIndex,
        PageSize: this.diagpageSize,
        AssessmentfileId: this.assessmentFile.Id,
      };
      await asseDetailbadmessage(params).then((res) => {
        if (res.data.success) {
          this.diagtotal = res.data.response.dataCount;
          this.Koufenmingxitable = res.data.response.data;
        }
      });
    },
    async getzzroptions () {
      await getzzrOptions().then((res) => {
        this.zrrOptions = res.data.response;
      });

    },
    //获取列表
    async handleQuery () {
      let parms = {
        fileId: this.assessmentFile.Id,
        key: this.input,
        page: this.pageIndex,
        intPageSize: this.pageSize,
        IsRatingAgency: false,
        zrrId: this.zrrId,
        isstorard: this.isstorard,
      };
      await getEvaluationAgencyList(parms).then((res) => {
        this.total = res.response.dataCount;
        this.tableData = res.response.data;

      });
    },
    //获取参数管理
    async getpublicParamsLs () {
      await GetPublicParamsLs().then((res) => {
        this.publicParam = res.data.response.data;

      });
    },
    //修改考核档案负责人
    async editAssementFile () {
      let params = {
        userId: this.PersonLiableId,
        realName: this.realName,
        fileId: this.assessmentFile.Id,
      }
      editAssementFile(params).then((res) => {
        this.assessmentFile.ScoreUserName = this.realName;
        this.assessmentFile.ScoreUserid = this.userId;
      });
    },
    async build () {
      if (this.checkValue == "") {
        this.$message({
          type: 'warning',
          message: '请先新建考核'
        });
        return
      }
      if (this.PersonLiableId == "") {
        this.$message({
          type: 'warning',
          message: '请先选择负责人'
        });
        return
      }
      if (this.assessmentFile.Id !== "") {
        this.$message({
          type: 'warning',
          message: '当前考核数据已经存在，不能重复生成'
        });
        return
      }
      if (this.assessmentFile.Id === "") {

        this.$confirm('此机构暂无考核档案，是否生成?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let loading = Loading.service({
            lock: true,
            text: '正在生成中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          console.log("当前选中的考核id" + this.checkValue);
          generateAssessment([this.hospitalId], this.checkValue).then((res) => {
            if (res.success == undefined && res) {
              loading.close();
              this.$message({
                type: 'success',
                message: '生成成功'
              });
              this.loadexidfile();
            }
            else {
              loading.close();
              this.$message({
                type: 'warning',
                message: '生成失败' + res.msg
              });
            }
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消生成'
          });
        });
        return;
      }
      else
        console.log("没有生成");
      await this.handleQuery()

    },
    async loadexidfile () {
      await this.getModulecount();
      await this.getzzroptions();
      await this.loadAssessmentFile()
      this.editAssementFile();
    },
    async getUsersQuery () {
      await getUsers().then((res) => {
        if (res.data.success) {
          this.users = res.data.response;
        }
      });
    },
    async getModulecount () {
      await getModuleStateCount().then((res) => {
        if (res.success) {
          this.modulestateCount = res.response;
        }
      });
    },
    //查询所有的考核档案
    async getassementfileList () {
      await getAssementFileList().then((res) => {
        if (res.data.success) {
          this.assementfileCount = res.data.response.dataCount;
        }
      });
    },
    getDeptNameById (deptId) {
      // 遍历部门数组，寻找与deptId匹配的部门对象
      for (var i = 0; i < this.depts.length; i++) {
        if (this.depts[i].key === deptId) {
          return this.depts[i].label; // 返回找到的部门名称
        }
      }
      return "未知部门"; // 如果找不到对应ID的部门，返回默认值或者空字符串，根据需求
    },
    ///下拉框展示名称
    labelContent (item) {
      return `${item.RealName} (${this.getDeptNameById(item.DepartmentId)}) - ${item.LoginName}`;
    },

    async getDeptList () {
      await GetDepartmentList().then((res) => {
        if (res.status == 200) {
          res.data.response.forEach((element) => {
            this.depts.push({ key: element.Id, label: element.Name, uid: element.Uid });
          });
        }
      });
    },
    handlePersonLiableChange () {
      const selectedUserId = this.dangantableForm.PersonLiableId;
      // 根据 selectedUserId 找到对应的用户对象
      const selectedUser = this.users.find(user => user.UId === selectedUserId);
      if (selectedUser) {
        // 将选中用户的 RealName 赋值给 ScoreUserName 字段
        this.realName = selectedUser.RealName;
      } else {
        this.realName = ''; // 如果没有找到对应用户，清空 urealname 字段
      }

    },
    //归档
    // async shenghestate () {
    //   this.$confirm(是否确认要归档, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.assessmentFile.State = 6;
    //     this.editfileState();
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消提交'
    //     });
    //   });
    //   this.tableData = [];
    //   this.assessmentFile = {
    //     HospitalName: "",
    //     Number: "",
    //     Id: "",
    //     State: "",
    //     ScoreUserName: ""
    //   };
    //   this.modulestateCount = [];
    //   this.assementfileCount = 0;
    //   this.zrrOptions = [];
    //   await this.loadApiData();
    // },
    async shenghestate () {
      try {
        await this.$confirm('是否确认要归档,归档后数据不能再操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 用户点击了确认按钮
        this.assessmentFile.State = 6;
        await this.editfileState();

        // 重置操作移到确认归档之后执行，而不是在前面立即执行
        this.tableData = [];
        this.assessmentFile = {
          HospitalName: '',
          Number: '',
          Id: '',
          State: '',
          ScoreUserName: ''
        };
        this.modulestateCount = [];
        this.assementfileCount = 0;
        this.zrrOptions = [];
        this.Koufenmingxitable = [];

        // 确认归档成功后，重新加载数据
        await this.loadApiData();

      } catch (error) {
        // 用户点击了取消按钮或者对话框关闭
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      }
    },
    async editfileState () {
      ///点击归档，可以修改分数
      let params = {};
      if (this.assessmentFile.State === 6) {
        params = {
          fileId: this.assessmentFile.Id,
          state: this.assessmentFile.State,
          score: this.modulestateCount.Socouresd,
        }
      } else {
        params = {
          fileId: this.assessmentFile.Id,
          state: this.assessmentFile.State,
        }
      }
      await editAssementFileState(params).then((res) => {
        if (res.success) {
        };
      });
    },
    getStateText (state) {
      switch (state) {
        case 1:
          return '未提交';
        case 2:
          return '已提交';
        case 3:
          return '未通过';
        case 4:
          return '已通过';
        case 5:
          return '已考核';
        case 6:
          return '已归档';
        default:
          return '';
      }

    },
    //选择责任人
    zzrchangehandler (zrrId) {
      this.zrrId = zrrId;
      this.pageIndex = 1;
      this.handleQuery();
      console.log("当前选中的值" + zrrId);
    },
    storardhandler (isstorard) {
      console.log("是否达标" + isstorard);
      this.isstorard = isstorard;
      this.pageIndex = 1;
      this.handleQuery();
    },
    //点击查询扣分按钮
    getkoufen () {
      this.diakoufenmxVisible = true;
      this.getassedetailbadmessage();
    },
    async start () {
      await this.getModulecount();
      await this.getzzroptions();
      await this.GetCheckData();
      this.loadApiData();
    },
    countmodulState (state) {
      return this.modulestateCount[state]; // 返回指定状态的数量
    }
  },
  mounted () {
    this.start();
    var user = JSON.parse(window.localStorage.user);
    this.hospitalId = user ? user.HospitalId : "";
  },
}

</script>

<style scope>
::v-deep .el-icon-close:before {
  font-size: 30px !important;
}

.grid-contentbutton {
  margin-top: 15px;
}
</style>